var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    [
      _c(
        "ht-action-panel",
        { attrs: { "on-search": _vm.onSearch, "on-clear": _vm.onClearSearch } },
        [
          _c(
            "template",
            { slot: "left" },
            [
              _c("el-input", {
                attrs: { placeholder: "工程名称" },
                model: {
                  value: _vm.listQuery.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.listQuery, "name", $$v)
                  },
                  expression: "listQuery.name",
                },
              }),
              _vm._v(" "),
              _c("el-input", {
                attrs: { placeholder: "工程地址" },
                model: {
                  value: _vm.listQuery.location,
                  callback: function ($$v) {
                    _vm.$set(_vm.listQuery, "location", $$v)
                  },
                  expression: "listQuery.location",
                },
              }),
              _vm._v(" "),
              _c("el-date-picker", {
                attrs: {
                  type: "daterange",
                  "range-separator": "至",
                  "value-format": "yyyy-MM-dd",
                  placement: "bottom-start",
                  "start-placeholder": "工程开始日期",
                  "end-placeholder": "工程结束日期",
                },
                model: {
                  value: _vm.createdAt,
                  callback: function ($$v) {
                    _vm.createdAt = $$v
                  },
                  expression: "createdAt",
                },
              }),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  attrs: { placeholder: "工程状态" },
                  model: {
                    value: _vm.listQuery.isFinished,
                    callback: function ($$v) {
                      _vm.$set(_vm.listQuery, "isFinished", $$v)
                    },
                    expression: "listQuery.isFinished",
                  },
                },
                _vm._l(_vm.ProjectStatusEnum, function (item) {
                  return _c("el-option", {
                    key: item.name,
                    attrs: { label: item.value, value: item.name },
                  })
                }),
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "ht-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.isLoading,
              expression: "isLoading",
            },
          ],
          ref: "list",
          staticStyle: { cursor: "pointer" },
          attrs: { data: _vm.list },
          on: { "row-click": _vm.handleRowClick },
        },
        [
          _c("ht-table-column", {
            attrs: { label: "序号", type: "index", fixed: "left" },
          }),
          _vm._v(" "),
          _vm._l(_vm.ProjectListTitle, function (item) {
            return _c("ht-table-column", {
              key: item.prop,
              attrs: {
                label: item.label,
                prop: item.prop,
                "min-width": item.width || 100,
                fixed: _vm.isMobile ? false : item.fixed,
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        item.label === "工程地址"
                          ? _c("span", [
                              _vm._v(
                                "\n          " +
                                  _vm._s(row[item.prop] || "-") +
                                  "\n          "
                              ),
                            ])
                          : item.label === "工程起止日期"
                          ? _c("span", [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    row.projectStartAt
                                      ? row.projectStartAt +
                                          "至" +
                                          row.projectEndAt
                                      : "-"
                                  ) +
                                  "\n        "
                              ),
                            ])
                          : item.label === "工程资料"
                          ? [
                              _c(
                                "el-link",
                                {
                                  attrs: {
                                    type:
                                      row.attachmentData &&
                                      row.attachmentData.length > 0
                                        ? "primary"
                                        : "info",
                                    disabled:
                                      row.attachmentData &&
                                      row.attachmentData.length === 0,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openDocumentDialog(row)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      (row.attachmentData &&
                                        row.attachmentData.length) ||
                                        0
                                    )
                                  ),
                                ]
                              ),
                            ]
                          : item.label === "绑定客户账号"
                          ? _c("span", [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    row.customer ? row.customer.fullName : "-"
                                  ) +
                                  "\n        "
                              ),
                            ])
                          : item.label === "关联工单"
                          ? [
                              _c(
                                "el-link",
                                {
                                  attrs: {
                                    type:
                                      row.workOrderCount > 0
                                        ? "primary"
                                        : "info",
                                    disabled: row.workOrderCount === 0,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openWorkOrderDialog(row)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(row.workOrderCount || 0))]
                              ),
                            ]
                          : item.label === "工程进度"
                          ? [
                              row[item.prop] || row[item.prop] === 0
                                ? _c("el-progress", {
                                    staticStyle: { width: "95%" },
                                    attrs: {
                                      percentage: row[item.prop],
                                      "show-text": !row.isFinished,
                                      color: row.isFinished
                                        ? "#e6ebf5"
                                        : "#2e5aff",
                                    },
                                  })
                                : [_vm._v("-")],
                            ]
                          : item.label === "工程状态"
                          ? _c(
                              "el-tag",
                              {
                                attrs: {
                                  type: _vm.getProjectStatus(row[item.prop])
                                    .style,
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.getProjectStatus(row[item.prop])
                                      .value || "-"
                                  )
                                ),
                              ]
                            )
                          : item.label === "现存设备数"
                          ? _c("span", [_vm._v(_vm._s(row[item.prop] || 0))])
                          : _c("span", [_vm._v(_vm._s(row[item.prop] || "-"))]),
                      ]
                    },
                  },
                ],
                null,
                true
              ),
            })
          }),
          _vm._v(" "),
          _vm.isMobile
            ? _c("ht-table-column-operation", {
                attrs: { width: 110 },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c("dw-table-dropdown-buttons", {
                            attrs: { buttons: row.buttons, row: row },
                            on: {
                              "handle-button-click": function ($event) {
                                return _vm.handleButtonClick(row, arguments)
                              },
                            },
                          }),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2614970760
                ),
              })
            : _c("ht-table-column-operation", {
                attrs: { width: 160 },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "ht-button",
                          {
                            attrs: {
                              disabled: row.isFinished,
                              type: "text",
                              icon: "el-icon-setting",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.openLeaseEquipmentMgrDialog(row)
                              },
                            },
                          },
                          [_vm._v("租用设备")]
                        ),
                        _vm._v(" "),
                        _c(
                          "ht-button",
                          {
                            attrs: { icon: "el-icon-view", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.onView(row)
                              },
                            },
                          },
                          [_vm._v("详情")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
        ],
        2
      ),
      _vm._v(" "),
      _c("ht-pagination", {
        staticStyle: { float: "right", "margin-bottom": "10px" },
        attrs: {
          total: _vm.page.total,
          page: _vm.listQuery.page,
          limit: _vm.listQuery.perPage,
        },
        on: {
          "update:page": function ($event) {
            return _vm.$set(_vm.listQuery, "page", $event)
          },
          "update:limit": function ($event) {
            return _vm.$set(_vm.listQuery, "perPage", $event)
          },
          pagination: _vm.getList,
        },
      }),
      _vm._v(" "),
      _c(
        "ht-dialog",
        {
          ref: "documentDialog",
          attrs: { title: "工程资料", width: _vm.isMobile ? "100%" : "800px" },
          on: { close: _vm.closeDocumentDialog },
        },
        [
          _c(
            "div",
            { attrs: { slot: "content" }, slot: "content" },
            [
              _vm.showDocumentList
                ? _c("document-list", {
                    ref: "documentList",
                    attrs: {
                      "document-list": _vm.documentList,
                      "show-operation": false,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "ht-dialog",
        {
          ref: "workOrderDialog",
          attrs: { title: "工程工单", width: _vm.isMobile ? "100%" : "1000px" },
          on: { close: _vm.closeWorkOrderDialog },
        },
        [
          _c(
            "div",
            { attrs: { slot: "content" }, slot: "content" },
            [
              _c(
                "el-tabs",
                {
                  on: { "tab-click": _vm.getWorkOrderList },
                  model: {
                    value: _vm.workOrderActiveName,
                    callback: function ($$v) {
                      _vm.workOrderActiveName = $$v
                    },
                    expression: "workOrderActiveName",
                  },
                },
                _vm._l(_vm.getTaskTempTypeEnum(), function (item, index) {
                  return _c("el-tab-pane", {
                    key: index,
                    attrs: { label: item.value, name: item.name },
                  })
                }),
                1
              ),
              _vm._v(" "),
              _vm.showWorkOrderList
                ? _c("work-order-list", {
                    ref: "workOrderList",
                    attrs: {
                      "is-loading": _vm.isWorkOrderLoading,
                      "table-title": _vm.workOrderTableTitle,
                      list: _vm.workOrderList,
                      page: _vm.workOrderPage,
                      "list-query": _vm.workOrderListQuery,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "ht-dialog",
        {
          ref: "leaseEquipmentMgrDialog",
          attrs: {
            title: "租用设备管理",
            width: _vm.isMobile ? "100%" : "800px",
          },
          on: { close: _vm.closeLeaseEquipmentMgrDialog },
        },
        [
          _c(
            "div",
            { attrs: { slot: "content" }, slot: "content" },
            [
              _vm.showLeaseEquipmentMgr
                ? _c("lease-equipment-mgr", {
                    ref: "leaseEquipmentMgr",
                    attrs: {
                      "is-view": "",
                      "project-id": _vm.projectId,
                      "project-data": _vm.projectData,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }